import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('bin_fill_fill_bin_into_bin'),
    MenuEntry.create()
        .setRoute('bin_fill_bin_transfer_queues'),
];
